// import axios from 'axios'

const moduleAuth = {
    namespace: true,
    state: {
        token: localStorage.getItem('access_token') || null
    },
    mutations: {
        // retrieveToken(state, token) {
        //     state.token = token
        // }
    },
    actions: {
        // retrieveToken(context, credentials) {
        //     axios.defaults.baseURL = 'http://localhost:8000/api'
        //     return new Promise((resolve, reject) => {
        //         axios.post('/login/', {
        //             username: credentials.username,
        //             password: credentials.password,
        //         }).then(response => {
        //             const token = response.data.token
        //             localStorage.setItem('access_token', token)
        //             context.commit('retrieveToken', token)
        //             resolve(response)
        //         }).catch(error => {
        //             console.log(error)
        //             reject(error)
        //         })
        //     })
        // }
    }
}

export default moduleAuth
